import { Badge } from '../../../ui/Badge';
import { Card } from '../../../ui/misc';
import { Timestamp } from '../../../ui/Timestamp';
import type { ImplDetail } from './types';

export function Progress({ i }: { i: ImplDetail }) {
  return (
    <Card title="Progress">
      {i.progress.length === 0 ? (
        <span className="small muted">No progress recorded.</span>
      ) : (
        <div className="timeline">
          {i.progress.map((p) => (
            <div key={p.id} className="timeline-item">
              <span className="small muted">
                <Timestamp value={p.createdAt} />
              </span>
              <span>
                {p.kind === 'blocker' && <Badge tone="error">Blocker</Badge>}{' '}
                {p.phase && <span className="strong">{p.phase}: </span>}
                <span style={{ whiteSpace: 'pre-wrap' }}>{p.note}</span>
              </span>
            </div>
          ))}
        </div>
      )}
    </Card>
  );
}
